import React from "react";

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {Triple3dCarousel} from "../triple-3d-carousel/components/triple-3d-carousel";
import styles from "./entity-carousel.module.scss";
import classNames from "classnames";
import {EntityCarouselItem} from "./entity-carousel.item";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {ENTITY_CAROUSEL_MIN_SIZE} from "../../consts";

export class EntityCarouselProps extends BaseProps {
  entities: Array<EntityViewModel>;
  itemIndex: Number;
  onItemChange: Function;
  activeItemWidth: Number;
  isSmallView: Boolean;
  isRtl: Boolean;
  isSingleItem: Boolean;
}

export const EntityCarousel = ({entities, itemIndex, onItemChange, activeItemWidth, isSmallView, isRtl, isSingleItem}: EntityCarouselProps) => {

  const carouselContainer = {
    showArrows: !isSmallView,
    slideEnabled: isSmallView && !isSingleItem,
    initialIndex: itemIndex,
    activeItemWidth: 60,
    className: classNames(styles.items_container),
    itemClassName: classNames(styles.item_container),
    isRtl,
    onChange: (index) => onItemChange(entities[index]),
    itemsShouldOverlap: true,
  }

  const fitArraySizeForCarousel = (items) => {
    let newFullArray = items;
    while (newFullArray.length <= ENTITY_CAROUSEL_MIN_SIZE) {
      newFullArray = [...newFullArray,...items];
    }
    return newFullArray;
  }

  if (entities.length > 1 && entities.length < ENTITY_CAROUSEL_MIN_SIZE){
    entities = fitArraySizeForCarousel(entities)
  }

  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView})}>
      <Triple3dCarousel {...carouselContainer}>
        {
          entities.map((entity: EntityViewModel) =>
            <EntityCarouselItem entity={entity} key={entity.id} isSmallView={isSmallView} isSingleItem={isSingleItem}/>)
        }
      </Triple3dCarousel>
    </div>
  )
}
